module.exports = __webpack_public_path__ + "static/media/InactivePin.4be81f3e.svg";